export default "__VITE_ASSET__CbuBRxRr__"